import { render, staticRenderFns } from "./mp_copyright.vue?vue&type=template&id=1cfc1a08&scoped=true"
import script from "./mp_copyright.vue?vue&type=script&lang=ts"
export * from "./mp_copyright.vue?vue&type=script&lang=ts"
import style0 from "./mp_copyright.vue?vue&type=style&index=0&id=1cfc1a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc1a08",
  null
  
)

export default component.exports